import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Language = 'fr' | 'en' | 'es';

type UIState = {
  language: Language;
  sidebarOpen: boolean;
  setLanguage: (lang: Language) => void;
  setSidebarOpen: (open: boolean) => void;
  toggleSidebar: () => void;
};

export const useUIStore = create<UIState>()(
  persist(
    (set) => ({
      language: 'fr',
      sidebarOpen: false,
      setLanguage: (language) => set({ language }),
      setSidebarOpen: (sidebarOpen) => set({ sidebarOpen }),
      toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
    }),
    { name: 'minishop-ui', partialize: (state) => ({ language: state.language }) },
  ),
);
